import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Element } from 'react-scroll';
import { propBool, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import InputError from '../../../../../../Ui/Common/InputError';
import PlainDatePicker from '../../../../../../Ui/Common/PlainDatePicker';
import PlainDatePickerHeader from '../../../../../../Ui/Common/PlainDatePickerHeader';
/**
 * セミナーの日時入力コンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SeminarOneFormDateField = (props) => {
    const { className, disabled, input, inputClassName, maxDate, meta, minDate, popperPlacement, showTimeSelect, } = props;
    return (_jsx(Element, Object.assign({ className: className, name: `${input.name}_view` }, { children: _jsx("div", Object.assign({ className: 'professional_seminar_one_form_date' }, { children: _jsxs("div", Object.assign({ className: 'date_inner field' }, { children: [_jsx(PlainDatePicker, { className: clsx('date_input', inputClassName), dateFormat: 'yyyy年MM月dd日 HH:mm', disabled: disabled || disabled, input: input, maxDate: maxDate, meta: meta, minDate: minDate, popperPlacement: popperPlacement, renderCustomHeader: PlainDatePickerHeader, showTimeSelect: showTimeSelect, timeCaption: '時刻', timeIntervals: 30 }), _jsx(InputError, { meta: meta })] })) })) })));
};
SeminarOneFormDateField.propTypes = {
    className: propStr(),
    disabled: propBool(),
    input: propShape().isRequired,
    inputClassName: propStr(),
    maxDate: propShape(),
    meta: propShape().isRequired,
    minDate: propShape(),
    popperPlacement: propStr(),
    showTimeSelect: propBool(),
};
SeminarOneFormDateField.defaultProps = {
    className: '',
    disabled: false,
    inputClassName: '',
    maxDate: undefined,
    minDate: undefined,
    popperPlacement: undefined,
    showTimeSelect: true,
};
export default SeminarOneFormDateField;
